import { useState } from 'react';

import { LookoBadge, LookoButton, VStack } from '@looko-design-system';
import { Box, Typography } from '@mui/material';
import { convertNewlineToJSX } from '@toss/react';
import { useSnackbar } from 'notistack';

import { useAppStoreHandler } from '../../hook/useNavigateStore';
import 모바일 from './assets/mobileModal/모바일.png';
import 데스크탑 from './assets/mobileModal/테스크탑.png';
import { share } from './share';

/**
 *  모바일 유도 모달
 */
export const 모바일_유도_모달 = ({ onClose }: { onClose: () => void }) => {
  const storeHandler = useAppStoreHandler();
  const { enqueueSnackbar } = useSnackbar();

  const [showDesktop, setShowDesktop] = useState(true);

  const handleShare = async () => {
    try {
      const result = await share({
        title: 'Looko AI',
        url: window.location.origin,
      });

      if (result === 'copiedToClipboard') {
        enqueueSnackbar('링크를 클립보드에 복사했습니다.', { variant: 'success' });
      } else if (result === 'failed') {
        enqueueSnackbar('공유하기가 지원되지 않는 환경입니다.', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('공유하기가 지원되지 않는 환경입니다.', { variant: 'error' });
    }
  };

  return (
    <Box
      height={'100vh'}
      justifyContent={'center'}
      style={{
        backgroundColor: 'white',
        borderRadius: 4,
        padding: 24,
        alignItems: 'center',
      }}
    >
      {showDesktop ? (
        <VStack py={3}>
          <VStack gap={2} alignItems={'center'} mb={20 / 8}>
            <img src={데스크탑} width={140} height={94} />
            <Typography textAlign={'center'} variant="H2_Looko">
              {convertNewlineToJSX('데스크톱/노트북으로\n이용해주세요')}
            </Typography>
            <Typography textAlign={'center'} variant="Body_Looko">
              {convertNewlineToJSX('데스크톱/노트북으로 아래 링크에\n접속해 서비스를 이용해주세요')}
            </Typography>
            <Typography textAlign={'center'} variant="Label_Looko" color={'text.disabled'}>
              {window.location.origin}
            </Typography>
          </VStack>
          <VStack gap={12 / 8}>
            <LookoButton
              onClick={handleShare}
              style={{
                paddingRight: 24,
                paddingLeft: 24,
              }}
            >
              위 링크 카카오톡으로 나에게 보내기
            </LookoButton>
            <LookoButton variant="outlined" onClick={() => setShowDesktop(false)}>
              닫기
            </LookoButton>
          </VStack>
        </VStack>
      ) : (
        <VStack py={3}>
          <VStack alignItems={'center'} height={'100%'} mb={20 / 8} gap={20 / 8}>
            <VStack alignItems={'center'} gap={0.5}>
              <LookoBadge label="잠깐!" />
              <Typography textAlign={'center'} variant="H2_Looko">
                Looko AI APP도 있어요
              </Typography>
              <Typography textAlign={'center'} variant="Body_Looko">
                {convertNewlineToJSX('모바일로 Looko AI를 이용하시려면\nAPP을 다운받아주세요')}
              </Typography>
            </VStack>
            <img src={모바일} width={263} height={126} />
          </VStack>
          <VStack gap={12 / 8}>
            <LookoButton
              onClick={storeHandler}
              style={{
                paddingRight: 24,
                paddingLeft: 24,
              }}
            >
              APP 다운받으러 가기
            </LookoButton>
            <LookoButton variant="outlined" onClick={() => onClose()}>
              닫기
            </LookoButton>
          </VStack>
        </VStack>
      )}
    </Box>
  );
};
